<template>
  <div style="margin-top: 40px">
    <GroupProccess :selectedItems="selected_requests"
                   @filterData="handleFilter"
                   :selectedTab="selectedTab"
                   :selectedTabTop="selectedTabTop" />
    <FilterRate @handleSearch="applayFilter"/>

    <template>
      <v-row>
        <v-col cols="12" sm="12" md="12" style="text-align: center">

          <!-- First set of buttons -->
          <div style="display: flex; justify-content: center; margin-bottom: 5px;">

            <div class="text-center center_buttons btns_" style="position: relative">
              <v-btn
                  class="white--text filter__border"
                  :style="{
              'background-color': selectedTabTop === 0 ? '#FF4A4A' : '#8E8E8E',
              'min-width': '240px',
              'border-color': selectedTabTop === 0 ? '#FF4A4A' : '#8E8E8E',
            }"
                  @click="tabsFilterTop(0)"
              >
            <span :style="{ color: selectedTabTop === 0 ? 'white' : 'white' }">
              سلبي
            </span>
                <div :class="[selectedTab === 1 && switchColor.classificationTypeNegative ? 'down__arrow' : '']"></div>
              </v-btn>
            </div>

            <div class="text-center right_buttons btns_" style="position: relative">
              <v-btn
                  class="white--text filter__border"
                  :style="{
              'background-color': selectedTabTop === 1 ? '#33AB5F' : '#8E8E8E',
              'border-color': selectedTabTop === 1 ? '#33AB5F' : '#8E8E8E',

              'min-width': '240px'
            }"
                  @click="tabsFilterTop(1)"
              >
            <span :style="{ color: selectedTabTop === 1 ? 'white' : 'white' }">
              إيجابي
            </span>
                <div :class="[selectedTabTop === 1 && switchColor.classificationTypePositive ? 'down__arrow' : '']"></div>
              </v-btn>
            </div>

          </div>

          <!-- Second set of buttons -->
          <div style="display: flex; justify-content: center; margin-bottom: 10px;">

            <div class="text-center center_buttons btns" style="position: relative">
              <v-btn
                  class=" white--text filter__border"
                  :style="{
              'background-color': selectedTab === 0 ? (selectedTabTop === 1 ? '#33AB5F' : '#FF4A4A') : '#8E8E8E',
              'border-color': selectedTab === 0 ? (selectedTabTop === 1 ? '#33AB5F' : '#FF4A4A') : '#8E8E8E',
              'min-width': '160px'
            }"
                  @click="tabsFilter(0)"
              >
            <span :style="{ color: selectedTab === 0 ? 'white' : 'white' }">
              الكل
            </span>
                <div :class="[selectedTab === 0 && switchColor.getAllRates ? 'down__arrow' : '']"></div>
              </v-btn>
            </div>

            <div class="text-center right_buttons btns" style="position: relative">
              <v-btn
                  class="white--text filter__border"
                  :style="{
              'background-color': selectedTab === 1 ? (selectedTabTop === 1 ? '#33AB5F' : '#FF4A4A') : '#8E8E8E',
              'border-color': selectedTab === 1 ? (selectedTabTop === 1 ? '#33AB5F' : '#FF4A4A') : '#8E8E8E',
              'min-width': '160px'
            }"
                  @click="tabsFilter(1)"
              >
            <span :style="{ color: selectedTab === 1 ? 'white' : 'white' }">
              تحت المعالجة
            </span>
                <div :class="[selectedTab === 1 && switchColor.notProccessedFromSalesManager ? 'down__arrow' : '']"></div>
              </v-btn>
            </div>

            <div class="text-center right_buttons btns" style="position: relative">
              <v-btn
                  class=" white--text filter__border"
                  :style="{
              'background-color': selectedTab === 2 ? (selectedTabTop === 1 ? '#33AB5F' : '#FF4A4A') : '#8E8E8E',
              'border-color': selectedTab === 2 ? (selectedTabTop === 1 ? '#33AB5F' : '#FF4A4A') : '#8E8E8E',
              'min-width': '160px'
            }"
                  @click="tabsFilter(2)"
              >
            <span :style="{ color: selectedTab === 2 ? 'white' : 'white' }">
              تمت معالجتة
            </span>
                <div :class="[selectedTab === 2 && switchColor.ProccessedFromSalesManager ? 'down__arrow' : '']"></div>
              </v-btn>
            </div>

          </div>

        </v-col>

      </v-row>
    </template>

    <new-table-component
        :class="[selectedTabTop === 1 ? 'main__tables' : 'main__tables_']"
        :showSelect="true"
        :selectTabTopValue="true"
        itemKey="request_id"
        :selectedRows.sync="selected_requests"
        :headers="getHeaders"
        :pagination="pagination"
        :limit="$store.state.counterOfShow"
        :items="tableData"
        :loading="loading"
        v-model="page"
    >
      <template slot="item.stars" slot-scope="props">
        <div class="text-center">
          <v-rating
              v-model="props.item.stars"
              bg-color="orange-lighten-1"
              color="yellow"
              readonly
          ></v-rating>
        </div>
      </template>


      <template slot="item.request.customer.name" slot-scope="props">
        <span v-if="!props.item.request?.customer?.name"></span>
        <v-tooltip bottom v-else>
          <template v-slot:activator="{ on }">
            <span v-on="on">{{
                props.item.request?.customer?.name.substring(0, 20) + "..."
              }}</span>
          </template>
          <div class="font-weight-bold  text-center">
            {{props.item.request?.customer?.name}} <br> {{ props.item.request?.customer?.mobile }}
          </div>
        </v-tooltip>
      </template>
      <template slot="item.request.req_date" slot-scope="props">
        <span v-if="!props.item.request?.req_date"></span>
        <v-tooltip bottom v-else>
          <template v-slot:activator="{ on }">
            <span v-on="on">{{
                props.item.request?.req_date
              }}</span>
          </template>
          <div class="font-weight-bold">
            {{ props.item.request?.req_date}}
          </div>
        </v-tooltip>
      </template>

      <template slot="item.request.user.name" slot-scope="props">
        <span v-if="!props.item.request?.user?.name"></span>
        <v-tooltip bottom v-else>
          <template v-slot:activator="{ on }">
            <span v-on="on">{{
                props.item.request?.user?.name.substring(0, 10) + "..."
              }}</span>
          </template>
          <div class="font-weight-bold">
            {{ props.item.request?.user?.name }}
          </div>
        </v-tooltip>
      </template>

      <template slot="item.request.comment" slot-scope="props">
        <span v-if="!props.item.request?.comment"></span>
        <v-tooltip bottom v-else>
          <template v-slot:activator="{ on }">
            <span v-on="on">{{
                props.item.request?.comment.split(' ').slice(0, 3).join(' ') + (props.item.request?.comment.split(' ').length > 3 ? '...' : '')
              }}</span>
          </template>
          <div class="font-weight-bold text-center">
            {{ props.item.request?.comment}} <br><b>({{ props.item.comment_date }})</b>
          </div>
        </v-tooltip>
      </template>

      <template slot="item.customer_service_name" slot-scope="props">
        <span v-if="!props.item.customer_service_name"></span>
        <v-tooltip bottom v-else>
          <template v-slot:activator="{ on }">
            <span v-on="on">{{ props.item.customer_service_name.substring(0, 15) + "..." }}</span>
          </template>
          <div class="font-weight-bold">{{ props.item.customer_service_name }}</div>
        </v-tooltip>
      </template>

      <template slot="item.class_id_cs_text" slot-scope="props">
        <span v-if="!props.item.class_id_cs_text"></span>
        <v-tooltip bottom v-else>
          <template v-slot:activator="{ on }">
            <span v-on="on">{{ props.item.class_id_cs_text.substring(0, 10) + "..." }}</span>
          </template>
          <div class="font-weight-bold">{{ props.item.class_id_cs_text }}</div>
        </v-tooltip>
      </template>

      <template slot="item.customer_service_note" slot-scope="props">
        <span v-if="!props.item.customer_service_note"></span>
        <v-tooltip bottom v-else>
          <template v-slot:activator="{ on }">
            <span v-on="on">{{
                props.item.customer_service_note.split(' ').slice(0, 3).join(' ') + (props.item.customer_service_note.split(' ').length > 3 ? '...' : '')
              }}</span>
          </template>
          <div class="font-weight-bold text-center">{{ props.item.customer_service_note }}</div>
        </v-tooltip>
      </template>

      <template slot="item.agent_class_note" slot-scope="props">
        <classification-cell :label="props.item.class_id_agent_text" :color="props.item.class_id_agent_color" :name="props.item.agent_name" :note="props.item.agent_notes" />
      </template>
      <template slot="item.cs_class_note" slot-scope="props">
        <classification-cell :label="props.item.class_id_cs_text" :color="props.item.class_id_cs_color" :name="props.item.customer_service_name" :note="props.item.cs_note" />
      </template>

      <template slot="item.quacomment" slot-scope="props">
        <span v-if="!props.item.quacomment"></span>
        <v-tooltip bottom v-else>
          <template v-slot:activator="{ on }">
            <span v-on="on">{{
                props.item.quacomment.substring(0, 50) + "..."
              }}</span>
          </template>
          <div class="font-weight-bold  text-center">
            {{ props.item.quacomment}} <br><b>({{ props.item.quacomment_date }})</b>
          </div>
        </v-tooltip>
      </template>

      <template slot="item.request.class_id_agent_text" slot-scope="props">
        <span v-if="!props.item.request?.class_id_agent_text"></span>
        <v-tooltip bottom v-else>
          <template v-slot:activator="{ on }">
            <span v-on="on">{{
                props.item.request?.class_id_agent_text.substring(0, 10) + "..."
              }}</span>
          </template>
          <div class="font-weight-bold">
            {{ props.item.request?.class_id_agent_text }}
          </div>
        </v-tooltip>
      </template>

      <template slot="item.request.source_text" slot-scope="props">
        <span v-if="!props.item.request?.source_text"></span>
        <v-tooltip bottom v-else>
          <template v-slot:activator="{ on }">
            <span v-on="on">{{
                props.item.request?.source_text.substring(0, 10) + "..."
              }}</span>
          </template>
          <div class="font-weight-bold">
            {{ props.item.request?.source_text }}
          </div>
        </v-tooltip>
      </template>

      <template slot="item.source" slot-scope="props">
        <span v-if="!props.item.source"></span>
        <v-tooltip bottom v-else>
          <template v-slot:activator="{ on }">
            <span v-on="on">{{
                props.item.source.substring(0, 10) + "..."
              }}</span>
          </template>
          <div class="font-weight-bold">
            {{ props.item.source }}
          </div>
        </v-tooltip>
      </template>
      <template slot="item.request.product" slot-scope="props">
        <span v-if="!props.item.request.product"></span>
        <v-tooltip bottom v-else>
          <template v-slot:activator="{ on }">
            <span v-on="on">{{
                props.item.request.product.substring(0, 10) + "..."
              }}</span>
          </template>
          <div class="font-weight-bold">
            {{ props.item.request.product }}
          </div>
        </v-tooltip>
      </template>
      <template slot="item.request.rejection" slot-scope="props">
        <span v-if="!props.item.request.rejection"></span>
        <v-tooltip bottom v-else>
          <template v-slot:activator="{ on }">
            <span v-on="on">{{
                props.item.request.rejection.substring(0, 10) + "..."
              }}</span>
          </template>
          <div class="font-weight-bold">
            {{ props.item.request.rejection }}
          </div>
        </v-tooltip>
      </template>
      <template slot="item.request_source" slot-scope="props">
        <span v-if="!props.item.request_source"></span>
        <v-tooltip bottom v-else>
          <template v-slot:activator="{ on }">
            <span v-on="on">{{
                props.item.request_source.substring(0, 10) + "..."
              }}</span>
          </template>
          <div class="font-weight-bold">
            {{ props.item.request_source }}
            <div v-if=" props.item.request_source == 'متعاون'">
              <b>({{ props.item.collaborator_name }})</b>
            </div>
          </div>
        </v-tooltip>
      </template>
      <template slot="item.old_request_source" slot-scope="props">
        <span v-if="!props.item.old_request_source"></span>
        <v-tooltip bottom v-else>
          <template v-slot:activator="{ on }">
            <span v-on="on">{{
                props.item.old_request_source.substring(0, 10) + "..."
              }}</span>
          </template>
          <div class="font-weight-bold">
            {{ props.item.old_request_source }}
            <div v-if=" props.item.old_request_source == 'متعاون'">
              <b>({{ props.item.request?.collaborator?.name }})</b>
            </div>
          </div>
        </v-tooltip>
      </template>
      <template slot="item.classification" slot-scope="props">
        <span v-if="!props.item.classification"></span>
        <v-tooltip bottom v-else>
          <template v-slot:activator="{ on }">
            <span v-on="on">{{
                props.item.classification.substring(0, 10) + "..."
              }}</span>
          </template>
          <div class="font-weight-bold">
            {{ props.item.classification }}
            <div v-if=" props.item.classification == 'مرفوض'">
              <b>({{ props.item.request?.rejection }})</b>
            </div>
          </div>
        </v-tooltip>
      </template>


      <template v-slot:[`item.action`]="{ item }">
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="#3F0E40" small depressed dark v-bind="attrs" v-on="on">
              <v-icon>mdi-dots-horizontal</v-icon>
            </v-btn>
          </template>
          <v-list>
            <SingleProcess :item="item['request_id']" :idOfRate="item['id']" :rateRecord="item" @refreshAfterProccesses="refreshDataAfterProccesses"/>
          </v-list>
        </v-menu>
        <v-btn small depressed dark color="#3F0E40" :style="{
                        'margin': '0px 2px',
                    }"  @click="isProccessed(item.id)" v-if="item.is_processed == 0">
          <v-list-item-icon class="ml-2">
            <svg xmlns="http://www.w3.org/2000/svg" width="16.153" height="16.007" viewBox="0 0 16.153 16.007">
              <g id="Icon_feather-check-circle" data-name="Icon feather-check-circle" transform="translate(-2.31 -2.338)">
                <path id="Path_5859" data-name="Path 5859" d="M17.756,9.694v.679A7.378,7.378,0,1,1,13.381,3.63" transform="translate(0 0)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
                <path id="Path_5860" data-name="Path 5860" d="M23.091,6l-7.378,7.385L13.5,11.172" transform="translate(-5.336 -1.529)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
              </g>
            </svg>
          </v-list-item-icon>
        </v-btn>


<!--        <v-list-item @click="isProccessed" v-if="rateRecord.is_processed == 0">
          <v-list-item-icon class="ml-2">
            <ProcessedIcon />
          </v-list-item-icon>
          <v-list-item-title>تمت المعالجة</v-list-item-title>
        </v-list-item>-->
      </template>
    </new-table-component>
    <OrderRequestSection
        v-if="this.$store.state.openOrderRequestSection"
        style="margin-top: 50px"
    />

    <TasksRequestSection
        v-if="this.$store.state.openTasksRequestSection"
        style="margin-top: 50px"
    />

    <AddTaskForRequest
        v-if="this.$store.state.openAddTaskForRequest"
        style="margin-top: 50px"
    />

    <TasksDetailsRequestSection
        v-if="this.$store.state.openTasksDetailsRequestSection"
        style="margin-top: 50px"
    />
  </div>
</template>
<script setup>
import Axios from "axios";
import { ref, onMounted, watch, onBeforeUnmount,computed } from "vue";
import { axiosInstance } from "@/axios/config";
import SingleProcess from "./SingleProcess.vue";
import FilterRate from "./FilterRate.vue";
import OrderRequestSection from "@/components/AdminComponent/OrderRequestSection.vue";
import TasksRequestSection from "@/components/AdminComponent/TasksRequestSection.vue";
import AddTaskForRequest from "@/components/AdminComponent/AddTaskForRequest.vue";
import TasksDetailsRequestSection from "@/components/AdminComponent/TasksDetailsRequestSection.vue";
import GroupProccess from "@/views/admin/Charts/DuplicatedCustomers/GroupProccess.vue";
import ClassificationCell from "@/components/Base/ClassificationCell.vue";
import { store } from "@/store";
import { color } from "highcharts";
import { ProcessedIcon } from "@/assets/adminIcons/processedIcon";
import {OrderHistory} from "@/assets/adminIcons/orderHistory";
import { EventBus } from '@/mixins/eventBus.js';

let loading = ref(false);
const headers = [
  { text: "تاريخ دخول الطلب للسله", value: "created_at", width: "120px",align: "center",},
  { text: "نوع المنتج", value: "request.product",align: "center", width: "120px" },
  { text: "تاريخ الطلب", value: "req_date",align: "center", width: "120px" },
  { text: " اسم العميل", value: "request.customer.name",align: "center", width: "120px" },
  { text: "استشاري المبيعات", value: "request.user.name",align: "center", width: "120px" },
  { text: "تصنيف الاستشاري", value: "classification",align: "center", width: "120px"  },
  { text: "سبب الرفض", value: "request.rejection",align: "center", width: "120px"  },
  { text: "ملاحظه الاستشاري", value: "request.comment", align: "center" },
  { text: "أسم خ ع", value: "customer_service_name", align: "center", width: "120px" },
  { text: "تصنيف خ ع", value: "class_id_cs_text", align: "center", width: "120px" },
  { text: "ملاحظة خ ع", value: "customer_service_note", align: "center", width: "120px" },
  { text: "الأستشاري", value: "agent_class_note", width: "180px", align: "center", sortable: false },
  { text: "خدمة العملاء", value: "cs_class_note", width: "180px", align: "center", sortable: false },
  { text: "ملاحظه الجودة", value: "request.quacomment",align: "center" },
  { text: "مصدر المعامله", value: "old_request_source",align: "center", width: "120px"  },
  { text: "مصدر محاوله التكرار", value: "request_source",align: "center", width: "120px" },
  { text: "يدوى - اتومتيك", value: "manual_auto",align: "center", width: "100px" },
  { text: "العمليات", value: "action",align: "center" , width: "140px"},
];

const switchColor = ref({
  getAllRates: true,
  notProccessedFromSalesManager: false,
  ProccessedFromSalesManager: false,
  classificationTypeNegative: false,
  classificationTypePositive: false,
  ProccessedFromAdmin: false,
});

const page = ref(1);
const number_of_stars = ref(null);
const filterData = ref({});

watch(page, (current) => {
  console.log("pppp", current, filterData)
  getData(current, filterData.value);
});

watch(() => store.state.counterOfShow,
    (newVal, oldVal) => {
      if (newVal !== oldVal) {
        getData(page.value, filterData.value)
      }
    }
);

watch(number_of_stars, (newVal) => {
  handleStarsFilter(newVal);
});

const getHeaders = computed(() => {
  if (selectedTab.value === 1) {
    return headers.filter(header => header.value !== "manual_auto");
  }  else {
    return headers;
  }
});

const handleFilter = (data) => {
  filterData.value = data;
  filterData.classification_type = data;
  tableData.value = [];
  page.value = 1;
  getData(1, data);
};


const handleStarsFilter = (stars) => {
  filterData.value.stars = stars;
  getData(page.value, filterData.value);
};

const pagination = ref({});
const tableData = ref([]);
let selectedTab = ref(1);
let selectedTabTop = ref(0);


const applayFilter = (count, data) => {
    store.state.duplicated_filter_data = data;
    // console.log("ddd", store.state.duplicated_filter_data , data)
    // console.log(store.state.duplicated_filter_data)
    getData(count, data);
};
const getData = (count, data) => {
  console.log('getDAta')
  console.log(data)
  loading.value = true;
  // console.log("ddd_", store.state.duplicated_filter_data )

  let body = new FormData();
  body.append("page", count);

  // if (store.state.duplicated_filter_data) {
    for (const key in store.state.duplicated_filter_data) {
      // console.log("key", key)
      if (data[key] !== "" && store.state.duplicated_filter_data[key] !== undefined && store.state.duplicated_filter_data[key] !== null) {
        body.append(key, store.state.duplicated_filter_data[key]);
      }
    }
  // }

  if(selectedTab.value == 0){
    switchColor.value.getAllRates = true;
    body.delete(`is_processed`);
  }

  if(selectedTab.value == 1){
    switchColor.value.notProccessedFromSalesManager = true;
    body.append(`is_processed`,0);
  }

  if(selectedTab.value == 2){
    switchColor.value.ProccessedFromSalesManager = true;
    body.append(`is_processed`,1);
  }
  if(selectedTabTop.value == 0){
    switchColor.value.notProccessedFromSalesManager = true;
    body.append(`classification_type`,0);
  }

  if(selectedTabTop.value == 1){
    switchColor.value.ProccessedFromSalesManager = true;
    body.append(`classification_type`,1);
  }


  axiosInstance
      .post(`/employee/admin/duplicated-customers?per_page=${store.state.counterOfShow}`, body)
      .then((res) => {
        const response = res.data.payload;
        tableData.value = response.data;
        let paginationCount = null;
        // if (data) {
        //   paginationCount = response.searched_count;
        // } else {
        //   paginationCount = response.total_count;
        // }

        paginationCount = response.searched_count;
        pagination.value = {
          limit: 3,
          count: paginationCount,
        };
        loading.value = false;
      })
      .catch((err) => (loading.value = false));
};

const isProccessedBySalesManager = (status) => {
  return status != 0 ? `نعم` : `لا`;
};

const isProccessedByAdmin = (status) => {
  return status == 2 ? `نعم` : `لا`;
};

const extractTime = (rateDate) => {
  // Regular expression to match the time part
  const timeRegex = /\d{2}:\d{2} [AP]M/;
  // Extract the time part using regex
  const timeMatch = rateDate.match(timeRegex);
  // If match found, return the time part
  return timeMatch ? timeMatch[0] : '';
};



const tabsFilter = (value) => {
  selectedTab.value = value;
  getData(page.value,filterData.value)
};


const tabsFilterTop = (value) => {
  selectedTabTop.value = value;
  getData(page.value,filterData.value)
};
const isProccessed = (value)=> {
  axiosInstance
      .post(`/employee/admin/convert-duplicate-to-proccess/${value}`)
      .then((res) => {
        refreshDataAfterProccesses()
       /* this.$emit("submitted");
        this.$root.$emit("popup", "success",  res.data.payload, "link", "copy");*/
      })
      .catch((err) => {
        this.showPopup("error", err.response.data.message);
      });
};


const refreshDataAfterProccesses = () => {
  getData(page.value,filterData.value)
};
onBeforeUnmount(() => {
  store.state.openOrderRequestSection = false;
});
let selected_requests = ref([]);
 const resetSelectedItems = () => {
  selected_requests = ref([]);
};



onMounted(() => {
  EventBus.$on('EmptySelectedRequests', refreshDataAfterProccesses );
  EventBus.$on('EmptySelectedRequests', resetSelectedItems );
  store.state.duplicated_filter_data = {};
  getData(1);
});

</script>

<style scoped>
.custom-tabs {
  border-bottom: 1px solid #ccc;
}

.custom-tab {
  color: white;
  font-weight: bold;
  transition: background-color 0.3s ease;
}

.custom-tab:hover {
  color: white;
}

.custom-tab-wrapper {
  background-color: #e3dce3;
  padding: 10px;
  margin: 5px;
  border-radius: 5px;
}

.custom-tabs-center-1 {
  display: flex !important;
  justify-content: right !important;
}

.custom-tabs-center-2 {
  display: flex !important;
  justify-content: left !important;
}

.btns .down__arrow {
  position: absolute;
  bottom: -19px;
  left: 50%;
  width: 0;
  display:none;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 8px solid rgb(255, 255, 255);
  transform: translateX(-50%);
}
.theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:not(:last-child) > td:not(.v-data-table__mobile-row) span, .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:not(:last-child) > th:not(.v-data-table__mobile-row) span, .v-data-table > .v-data-table__wrapper > table > tbody > tr > td span, .v-data-table > .v-data-table__wrapper > table > thead > tr > td span, .v-data-table > .v-data-table__wrapper > table > tfoot > tr > td span {
  font-family: Dintext !important;
}
.filter__border {
  height: 38px !important;
  font-size: 15px !important;
  border: 1px solid rgb(63, 14, 64);
}
.v-btn--is-elevated {
   box-shadow: none;
}
.btns .v-btn {
  align-items: center;
  border-radius: 0px;
}
.btns_ .v-btn {
  align-items: center;
  border-radius: 0px;
}
.v-application .ma-2 {
  margin: 8px 0px !important;
}
</style>
